<div id="ineligibility-content">
  <picture>
    <source media="(min-width: 767px)" srcset="assets/images/no-large.png">
    <img id="ineligibility-icon" src="assets/images/no.png" alt="Ineligibility icon">
  </picture>
  <h2 id="ineligibility-heading"><strong>{{cfetLabels.cfet_customer_eligibility.ineligibility_heading}}</strong></h2>
  <p id="ineligibility-desc">
    <strong>{{cfetLabels.cfet_customer_eligibility.ineligibility_desc}}</strong>
  </p>
  <span>
    {{cfetLabels.cfet_customer_eligibility.ineligibility_text}}
    <a href="https://www.att.com/">{{cfetLabels.cfet_customer_eligibility.att_link_text}}</a>
  </span>
</div>